import React from 'react'
import Icon from '../../icon'
import './index.less'

export default ({ selects, onClear, mode, onMode }) => {
  return <div className="idea-mass-wrapper-right-header">
    <div>
      选择灵感集
      {
        !!selects.length && <span>
          <span className="idea-mass-wrapper-right-header-selected">已选<i>{selects.length}</i></span>
          <span
            className="idea-mass-wrapper-right-header-clear"
            onClick={() => {
              onClear()
            }}
          >清空</span>
        </span>
      }
    </div>
    <div
      className="idea-mass-wrapper-right-header-switch"
      onClick={() => {
        onMode(!mode)
      }}
    >
      <Icon type="m-qiehuan" /><span style={{ marginLeft: '4px' }}>{!mode ? '单选' : '多选'}</span>
    </div>
  </div>
}
